export enum NoCostLoginMethod {
  Biometrics = 1,
  QuickLogin = 2,
}
